import Api from '../api/api.js';


class AssessQuestions {


	init()
	{
		this.cacheDom();

		this.initDatepickers();

		this.initStepper();
	}


	cacheDom()
	{
		this.$assessment_date = $('#assessment-date');

		this.$stepper = $('.stepper');
	}


	initDatepickers()
	{
		this.initAssessmentDatepicker();
	}	


	initAssessmentDatepicker()
	{
		this.$assessment_date.pickadate({

			hiddenName:true, 

			formatSubmit:'yy-mm-dd'

		});

	    const value = this.$assessment_date.data('value');

	    if (value) {

	        this.$assessment_date.pickadate('picker').set('select', new Date(value));
	    
	    }
	}


	initStepper()
	{
		this.$stepper.mdbStepper();
	}

}


class AssessTasks {


	init(assessment_id, user_id)
	{
		this.user_id = user_id;

		this.assessment_id = assessment_id
	
		this.cacheDom();

		this.initDatepickers();

		this.initStepper();
	}


	cacheDom()
	{
		this.$assessment_date = $('#assessment-date');

		this.$task_row = $('.student-task-row');

		this.$task_dates = this.$task_row.find('.datepicker');

		this.$stepper = $('.stepper');

		this.$task_progress = $('#task-progress');
	}


	findDate(task_id)
	{
		return $('.student-task-row').find('input[data-task=' + task_id + ']');
	}


	initDatepickers() 
	{
		this.initTaskDatepickers();

		this.initAssessmentDatepicker();
	}


	initTaskDatepickers()
	{
		var _this = this;

		this.$task_dates.pickadate({
			
			hiddenName:true,

			formatSubmit:'yy-mm-dd'
		
		});

		this.$task_dates.each(function() {

			const $date = $(this);

			const value = $date.data('value');
			
			const $picker = $date.pickadate('picker');

			var $row = $date.closest('.student-task-row');

    		const task_id = $row.data('task');

    		if (value) {

      			$picker.set('select', new Date(value));
    		
    		}

    		$picker.on('set', function(event) {

    			if (event.select) {

					_this.completeTask(_this.user_id, task_id, $picker.get('value'));

				} else {
	
					_this.uncompleteTask(_this.user_id, task_id);

    			} 

			});
		});
	}


	initAssessmentDatepicker()
	{
		this.$assessment_date.pickadate({

			hiddenName:true, 

			formatSubmit:'yy-mm-dd'

		});

	    const value = this.$assessment_date.data('value');

	    if (value) {

	        this.$assessment_date.pickadate('picker').set('select', new Date(value));
	    
	    }
	}


	initStepper()
	{
		this.$stepper.mdbStepper();
	}


	isCompleted($date)
	{
		const val = $date.pickadate('picker').get('value');

		return val.length > 0;
	}


	refreshLineThrough(task_id)
	{
		const $date = this.findDate(task_id);

		const checked = this.isCompleted($date);

		const $label = $date.closest('.student-task-row').find('.checklist label');

		if (checked) {

			$label.addClass('checked');

		} else {

			$label.removeClass('checked');

		}
	}


	lastUpdated(task_id)
	{
		this.refreshLineThrough(task_id);

		this.refreshProgress();
	}


	refreshProgress()
	{
		(new Api).getRequest(`/admin/users/${this.user_id}/assessments/${this.assessment_id}/tasks/partials`, {}).then((response) => {

			this.$task_progress.html(response.progress);
		
		});
	}


	completeTask(user_id, task_id, completed)
	{ 
		const data = {completed};

		(new Api).postRequest(`/admin/users/${user_id}/tasks/${task_id}`, data).then(() => {

			this.lastUpdated(task_id);
		
		}, () => {
			
			this.lastUpdated(task_id);
		
		});
	}


	uncompleteTask(user_id, task_id)
	{
		(new Api).deleteRequest(`/admin/users/${user_id}/tasks/${task_id}`, {}).then(() => {

			this.lastUpdated(task_id);
		
		}, function() {
		
			this.lastUpdated(task_id);
		
		});
	}


	populateDate(task_id)
	{
		$('input.datepicker[data-task=' + task_id + ']').pickadate('picker').set("select", new Date);
	}


 	clearDate(task_id)
	{
		$('input.datepicker[data-task=' + task_id + ']').pickadate('picker').set('select', null);
	}


}


export default class AssessUser {
	
	
	init(params = {})
	{
		switch (params.type) {

			case 'questions':
				(new AssessQuestions).init();
			break;

			case 'tasks':
				(new AssessTasks).init(params.assessment_id, params.user_id);
			break;

			default:
				throw new Error('Unknown assessment type');

		}
	}

}